<template>
	<el-dialog
		:visible="visible"
		width="614px"
		:before-close="handleClose"
		fit="cover"
		:append-to-body="true"
		class="dialog"
	>
		<div class="role-introduce">
			<div class="introduce">
				<div class="introduce-avatar" v-if="memberInfo.photo">
					<img :src="memberInfo.photo" alt="" />
				</div>

				<div class="introduce-info">
					<p class="introduce-info-name text-overflow">{{ memberInfo.name }}</p>
					<p class="introduce-info-position text-overflow" v-if="memberInfo.position">
						{{ memberInfo.position }}
					</p>
				</div>
			</div>
			<div class="desc">
				<span v-if="memberInfo.abstractText">
					{{ memberInfo.abstractText }}
				</span>
				<div class="desc-empty" v-else>
					<div class="empty_content">
						<img src="@/assets/images/empty_details.png" alt="" />
						<p>{{ $t('enterprise.no-structure-data') }}</p>
					</div>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script setup>
defineProps({
	visible: {
		type: Boolean,
		default: false
	},
	memberInfo: {
		type: Object,
		default: () => ({})
	}
});
const emits = defineEmits(['update:visible']);

const handleClose = () => {
	emits('update:visible', false);
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
	padding-top: 12px !important;
	border: 0 !important;
}
.dialog {
	backdrop-filter: blur(14px);
}
.role-introduce {
	width: 100%;

	.introduce {
		display: flex;
		height: 54px;

		&-avatar {
			margin: auto 0;
			margin-right: 12px;
			width: 48px;
			height: 48px;
			img {
				width: 100%;
				height: 100%;
				border-radius: 50%;
				object-fit: cover;
			}
		}

		&-info {
			display: flex;
			flex-direction: column;
			justify-content: center;
			width: 0;
			flex: 1;
			&-name {
				color: #1d2129;
				 
				font-size: 20px;
				 
				font-weight: 500;
				line-height: 28px; /* 140% */
			}
			&-position {
				margin-top: 8px;
				color: var(--t-emphasis-color, #1d2129);
				 
				font-size: 14px;
				 
				font-weight: 400;
				line-height: 18px; /* 128.571% */
			}
		}
	}
	.desc {
		max-height: 286px;
		overflow: auto;
		margin-top: 20px;
		color: var(--t-secondary-color, #4e5969);
		 
		font-size: 14px;
		 
		font-weight: 400;
		line-height: 26px; /* 185.714% */
		&::-webkit-scrollbar {
			display: none;
		}
		.desc-empty {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			p {
				color: var(--t-secondary-color, #4e5969);
				text-align: center;
				 
				font-size: 12px;
				 
				font-weight: 400;
				line-height: 16px; /* 133.333% */
			}
		}
	}
}
</style>
